import React from "react"
import { Box, useMediaQuery } from "@material-ui/core"
import { useTheme } from "@material-ui/core/styles"
import Simulations from "./simulation-viewer/simulations"

export default function Simulator() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <Box
      flexDirection={isMobile ? "column" : "row"}
      width="100%"
      height="100%"
      minHeight={isMobile ? 600 : 400}
    >
      <Simulations />
    </Box>
  )
}